const EARTHLY_MAP = {
  子: 0,
  丑: 1,
  寅: 2,
  卯: 3,
  辰: 4,
  巳: 5,
  午: 6,
  未: 7,
  申: 8,
  酉: 9,
  戌: 10,
  亥: 11,
}

const TIAN_GAN = ['甲', '乙', '丙', '丁', '戊', '己', '庚', '辛', '壬', '癸']
const DI_ZHI = [
  '子',
  '丑',
  '寅',
  '卯',
  '辰',
  '巳',
  '午',
  '未',
  '申',
  '酉',
  '戌',
  '亥',
]

const LUNAR_MONTHS = [
  '正月',
  '二月',
  '三月',
  '四月',
  '五月',
  '六月',
  '七月',
  '八月',
  '九月',
  '十月',
  '十一月',
  '十二月',
]
const LEAP_LUNAR_MONTHS = [
  '闰一月',
  '闰二月',
  '闰三月',
  '闰四月',
  '闰五月',
  '闰六月',
  '闰七月',
  '闰八月',
  '闰九月',
  '闰十月',
  '闰十一月',
  '闰十二月',
]

const LUNAR_DATES = [
  '初一',
  '初二',
  '初三',
  '初四',
  '初五',
  '初六',
  '初七',
  '初八',
  '初九',
  '初十',
  '十一',
  '十二',
  '十三',
  '十四',
  '十五',
  '十六',
  '十七',
  '十八',
  '十九',
  '二十',
  '廿一',
  '廿二',
  '廿三',
  '廿四',
  '廿五',
  '廿六',
  '廿七',
  '廿八',
  '廿九',
  '三十',
]

// 四化依附主星，根據天干
const FOURMODE_ATTACH_STAR = {
  0: ['廉貞', '破軍', '武曲', '太陽'],
  1: ['天機', '天梁', '紫微', '太陰'],
  2: ['天同', '天機', '文昌', '廉貞'],
  3: ['太陰', '天同', '天機', '巨門'],
  4: ['貪狼', '太陰', '右弼', '天機'],
  5: ['武曲', '貪狼', '天梁', '文曲'],
  6: ['太陽', '武曲', '天同', '天相'],
  7: ['巨門', '太陽', '文曲', '文昌'],
  8: ['天梁', '紫微', '左輔', '武曲'],
  9: ['破軍', '巨門', '太陰', '貪狼'],
}

const PALACE_SHORT_NAME = {
  0: '命',
  1: '兄',
  2: '夫',
  3: '子',
  4: '財',
  5: '疾',
  6: '遷',
  7: '友',
  8: '官',
  9: '宅',
  10: '福',
  11: '父',
}

const PALACE_NAME = {
  0: '命宫',
  1: '兄弟',
  2: '夫妻',
  3: '子女',
  4: '财帛',
  5: '疾厄',
  6: '迁移',
  7: '交友',
  8: '事业',
  9: '田宅',
  10: '福德',
  11: '父母',
}

const FOURMODE_MAP = {
  0: '禄',
  1: '权',
  2: '科',
  3: '忌',
}

const DECADE_PALACE_NAME = {
  0: '限命',
  1: '限兄',
  2: '限夫',
  3: '限子',
  4: '限财',
  5: '限疾',
  6: '限迁',
  7: '限友',
  8: '限官',
  9: '限宅',
  10: '限福',
  11: '限父',
}

const YEALRLY_PALACE_NAME = {
  0: '年命',
  1: '年兄',
  2: '年夫',
  3: '年子',
  4: '年财',
  5: '年疾',
  6: '年迁',
  7: '年友',
  8: '年官',
  9: '年宅',
  10: '年福',
  11: '年父',
}

const NEED_OTHERS = [
  '红鸾',
  '天喜',
  '咸池',
  '天姚',
  '天马',
  '蜚廉',
  '禄存',
  '孤辰',
  '寡宿',
  '天刑',
]

const NEED_DECADE_STAR = ['羊', '陀', '鸾', '喜', '禄', '马']
const CLASS1 = ['天马', '禄存']
// const CLASS3 = ['擎羊', '陀羅', '火星', '鈴星', '地空', '地劫']
const STUDY_STARS = [
  '紫微',
  '天机',
  '太阳',
  '武曲',
  '天同',
  '天府',
  '太阴',
  '贪狼',
  '巨门',
  '天梁',
  '七杀',
  '破军',
  '廉贞',
  '天相',
  '天魁',
  '天钺',
  '左辅',
  '右弼',
  '文昌',
  '文曲',
  '陀罗',
  '陀螺',
  '擎羊',
  '火星',
  '铃星',
  '地空',
  '地劫',
  '禄存',
  '天马',
  '红鸾',
  '天喜',
  '天刑',
  '天姚',
]

const SORTING_ID = {
  紫微: 1,
  天机: 2,
  太阳: 3,
  武曲: 4,
  天同: 5,
  廉贞: 6,
  天府: 7,
  太阴: 8,
  贪狼: 9,
  巨门: 10,
  天相: 11,
  天梁: 12,
  七杀: 13,
  破军: 14,
  文昌: 1001,
  文曲: 1002,
  左辅: 1003,
  右弼: 1004,
  天魁: 1005,
  天钺: 1006,
  擎羊: 1007,
  陀罗: 1008,
  火星: 1009,
  铃星: 1010,
  地劫: 1011,
  地空: 1012,
  禄存: 1013,
  天马: 1014,
  红鸾: 2001,
  天喜: 2002,
  天姚: 2003,
  天刑: 2004,
}

const getRelativePalace = (customPalaceId, PalaceId) => {
  return PALACE_SHORT_NAME[customPalaceId] + '之' + PALACE_SHORT_NAME[PalaceId]
}

const checkFourmodeAttachStar = (heavenlyId, starName) => {
  return FOURMODE_ATTACH_STAR[heavenlyId].indexOf(starName)
}

const processPalace = (data) => {
  let palaceList = [...data.palObj]
  palaceList.sort(function (a, b) {
    return a.EarthlyID - b.EarthlyID
  })

  // 紅色 - 主星 - mainstar - class0
  // 紫色 - 輔星 - luckystar / badstar - class1
  // 淺藍色 - 雜曜 - otherstar - class2
  palaceList.forEach((palace) => {
    palace.stars = {}
    Object.entries(palace.MainStar).forEach(([key, value]) => {
      palace.stars[key] = {}
      palace.stars[key].brightness = value
      palace.stars[key].class = 0
      palace.stars[key].fourMode = { 0: null, 1: null, 2: null, 3: null }
    })
    Object.entries(palace.LuckyStar).forEach(([key, value]) => {
      palace.stars[key] = {}
      palace.stars[key].brightness = value
      palace.stars[key].class = 1
      palace.stars[key].fourMode = { 0: null, 1: null, 2: null, 3: null }
    })
    Object.entries(palace.BadStar).forEach(([key, value]) => {
      palace.stars[key] = {}
      palace.stars[key].brightness = value
      palace.stars[key].class = 1
      palace.stars[key].fourMode = { 0: null, 1: null, 2: null, 3: null }
    })
    Object.entries(palace.OtherStar).forEach(([key, value]) => {
      if (NEED_OTHERS.includes(key)) {
        palace.stars[key] = {}
        palace.stars[key].brightness = value
        palace.stars[key].class = 2
        palace.stars[key].fourMode = { 0: null, 1: null, 2: null, 3: null }
      }
    })
    palace.decade = {}
    palace.decade.stars = []
  })

  //第一階：四種四化, 0:生年(本命), 1:大限, 2:小限, 3:流年
  //第二階：0祿, 1權, 2科, 3忌
  //第三階：主星ID, 哪個位置(子..亥

  data.AllFourMode.forEach((fourMode) => {
    fourMode.forEach((item) => {
      const starClass = item[0]
      const star = FOURMODE_MAP[item[1]]
      try {
        palaceList[EARTHLY_MAP[item[3]]].stars[item[2]].fourMode[starClass] =
          star
      } catch (e) {
        console.log(e)
      }
    })
  })

  // 處理大限星
  data.All10YearStar[0].forEach((starObj) => {
    const star = starObj[0]
    const positionName = starObj[1]
    // const positionId = EARTHLY_MAP[positionName]
    if (NEED_DECADE_STAR.includes(star[1])) {
      palaceList[EARTHLY_MAP[positionName]].decade.stars.push(star)
    }
  })

  // console.log(palaceList)
  let thisYear = new Date().getFullYear()

  let result = []
  palaceList.forEach((palace) => {
    let newPalace = {}
    newPalace.palaceId = palace.PalaceID[0]
    newPalace.palaceName = PALACE_NAME[palace.PalaceID[0]]
    newPalace.isBodyPalace = palace.isBodyPalace
    newPalace.yearMonth = palace.YearMonth
    newPalace.earthlyId = palace.EarthlyID
    newPalace.earthlyName = palace.EarthlyName
    newPalace.heavenlyId = palace.HeavenlyID
    newPalace.heavenlyName = palace.HeavenlyName
    newPalace.longLiveGod = palace.LongLiveGod
    newPalace.doctorGod = palace.DoctorGod
    newPalace.generalGod = palace.GeneralGod[0]
    newPalace.yearGod = palace.YearGod[0]

    newPalace.decade = {}
    if (thisYear - data.Luna_Year > data.FiveElement - 1) {
      newPalace.decade.palaceId = palace.PalaceID[1]
    } else {
      newPalace.decade.palaceId = -1
    }
    newPalace.decade.palaceName = DECADE_PALACE_NAME[palace.PalaceID[1]]
    newPalace.decade.generalGod = palace.GeneralGod[1]
    newPalace.decade.yearGod = palace.YearGod[1]
    newPalace.decade.stars = palace.decade.stars

    newPalace.yearly = {}
    if (thisYear - data.Luna_Year > data.FiveElement - 1) {
      newPalace.yearly.palaceId = palace.PalaceID[2]
    } else {
      newPalace.yearly.palaceId = -1
    }

    newPalace.yearly.palaceName = YEALRLY_PALACE_NAME[palace.PalaceID[2]]
    newPalace.yearly.generalGod = palace.GeneralGod[2]
    newPalace.yearly.yearGod = palace.YearGod[2]

    newPalace.stars = []

    Object.entries(palace.stars).forEach(([key, value]) => {
      let star = { ...value }
      key = key == '陀螺' ? '陀羅' : key

      if (CLASS1.includes(key)) {
        star.class = 1
      }

      if (STUDY_STARS.includes(key)) {
        star.name = key
        star.fourModeStar = -1
        newPalace.stars.push(star)
      }

      star.sortingId = SORTING_ID[key] ? SORTING_ID[key] : 9999
    })

    newPalace.stars.sort(function (a, b) {
      return a.sortingId - b.sortingId
    })

    newPalace.ageGap =
      palace.Begin10Age.toString() + ' - ' + palace.End10Age.toString()

    result.push(newPalace)
  })

  return result
}

const getLifePalace = (data) => {
  let palaceList = [...data.palObj]
  palaceList.sort(function (a, b) {
    return a.EarthlyID - b.EarthlyID
  })

  let lifePositionId = -1
  let decadeLifePositionId = -1
  let yearlyLifePositionId = -1

  palaceList.forEach((palace) => {
    if (palace.PalaceID[0] === 0) lifePositionId = palace.EarthlyID
    if (palace.PalaceID[1] === 0) decadeLifePositionId = palace.EarthlyID
    if (palace.PalaceID[2] === 0) yearlyLifePositionId = palace.EarthlyID
  })

  return { lifePositionId, decadeLifePositionId, yearlyLifePositionId }
}

const getLunarChineseDate = function (year, month, day, isLeap) {
  let mod60Days = (year - 3) % 60
  const heavenly = TIAN_GAN[(mod60Days % 10) - 1 < 0 ? 9 : (mod60Days % 10) - 1]
  const earthly = DI_ZHI[(mod60Days % 12) - 1 < 0 ? 11 : (mod60Days % 12) - 1]
  let monthStr = LUNAR_MONTHS[month - 1]
  if (isLeap) {
    monthStr = LEAP_LUNAR_MONTHS[month - 1]
  }

  return heavenly + earthly + '年' + monthStr + LUNAR_DATES[day - 1]
}

export default {
  processPalace,
  getRelativePalace,
  checkFourmodeAttachStar,
  getLunarChineseDate,
  getLifePalace,
  PALACE_NAME,
}
